import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { auth } from '@/plugins/firebase';
import TranscribeView from '@/views/TranscribeView.vue';
import UploadView from '@/views/UploadView.vue';
import AuthView from '@/views/AuthView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'transcribe',
    component: TranscribeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/upload',
    name: 'upload',
    component: UploadView,
    meta: { requiresAuth: true },
  },
  {
    path: '/signin',
    name: 'signin',
    component: AuthView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = auth.currentUser;

  if (requiresAuth && !isAuthenticated) {
    next('/signin');
  } else {
    next();
  }
});

export default router;
